import { TypographyProps } from "@mui/material/Typography";

import { FONT_DISPLAY_STACK } from "@/themes/shared/fontStacks";

export const commonTheme = {
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "inherit",
        },
      },
    },
  },
};

// H1–H3 follow the brand type scale: Aeonik Fono Regular with negative
// tracking, at dashboard sizes rather than the marketing sizes (62/48/32px).
export const commonTypography = {
  MuiTypography: {
    variants: [
      {
        props: { variant: "h1" as TypographyProps["variant"] },
        style: {
          color: "inherit",
          fontFamily: FONT_DISPLAY_STACK,
          fontSize: "1.75rem",
          fontStyle: "normal",
          fontWeight: 400,
          letterSpacing: "-0.02em",
          marginBottom: "1.5rem",
        },
      },
      {
        props: { variant: "h2" as TypographyProps["variant"] },
        style: {
          color: "inherit",
          fontFamily: FONT_DISPLAY_STACK,
          fontSize: "1.25rem",
          fontStyle: "normal",
          fontWeight: 400,
          letterSpacing: "-0.02em",
          marginTop: "1rem",
          marginBottom: "1rem",
        },
      },
      {
        props: { variant: "h3" as TypographyProps["variant"] },
        style: {
          color: "inherit",
          fontFamily: FONT_DISPLAY_STACK,
          fontSize: "1.1rem",
          fontStyle: "normal",
          fontWeight: 400,
          letterSpacing: "-0.015em",
          marginBottom: "1rem",
        },
      },
      {
        props: { variant: "h4" as TypographyProps["variant"] },
        style: {
          color: "inherit",
          fontSize: "1.0rem",
          fontStyle: "normal",
          fontWeight: "normal",
        },
      },
    ],
  },
};
